import React from 'react';
import { Form, Divider } from 'semantic-ui-react'

const HomeCli1 = ({autorizacUA, styles, handleChange, handleSubmit, handleClickDir,
                  handleClickTC, handleClickGA, handleClickTD, handleClickCF, handleClickOP,
                  handleClickOf, handleClickSeg, handleClickPaq, args, nombreCiudadUA, descrDptoUA}) => {
  if(args.numDocum){
    let numDocum = document.getElementById("numDocum");
    if(numDocum){numDocum.value = args.numDocum}
  }
  if(args.contrato){
    let contrato = document.getElementById("contrato");
    if(contrato){contrato.value = args.contrato}
  }
  if(args.nombreCliente){
    let nombreCliente = document.getElementById("bnombreCliente");
    if(nombreCliente){nombreCliente.value = args.nombreCliente}
  }
  if(args.apellidoCliente){
    let apellidoCliente = document.getElementById("bapellidoCliente");
    if(apellidoCliente){apellidoCliente.value = args.apellidoCliente}
  }
  if(args.descrClaseServ){
    let descrClaseServ = document.getElementById("bdescrClaseServ");
    if(descrClaseServ){descrClaseServ.value = args.descrClaseServ}
  }
  if(args.descrSubclaseServ){
    let descrSubclaseServ = document.getElementById("bdescrSubclaseServ");
    if(descrSubclaseServ){descrSubclaseServ.value = args.descrSubclaseServ}
  }

  if(descrDptoUA){
    if(descrDptoUA==="Todos..."){
      if(args.descrDpto){
        let descrDpto = document.getElementById("bdescrDpto");
        if(descrDpto){descrDpto.value = args.descrDpto}
      }
    }else{
      let descrDpto = document.getElementById("bdescrDpto");
      if(descrDpto){
        descrDpto.value = descrDptoUA
      }
    }
  }
  if(nombreCiudadUA){
    if(nombreCiudadUA==="Todas..."){
      if(args.nombreCiudad){
        let nombreCiudad = document.getElementById("bnombreCiudad");
        if(nombreCiudad){nombreCiudad.value = args.nombreCiudad}
      }
    }else{
      let nombreCiudad = document.getElementById("bnombreCiudad");
      if(nombreCiudad){
        nombreCiudad.value = nombreCiudadUA
      }
    }
  }
  if(args.nombreZona){
    let nombreZona = document.getElementById("bnombreZona");
    if(nombreZona){nombreZona.value = args.nombreZona}
  }
  if(args.nombreBarrio){
    let nombreBarrio = document.getElementById("bnombreBarrio");
    if(nombreBarrio){nombreBarrio.value = args.nombreBarrio}
  }

  if(args.descrTipoVia1){
    let descrTipoVia1 = document.getElementById("bdescrTipoVia1");
    if(descrTipoVia1){descrTipoVia1.value = args.descrTipoVia1}
  }
  if(args.numeroTipoVia1){
    let numeroTipoVia1 = document.getElementById("bnumeroTipoVia1");
    if(numeroTipoVia1){numeroTipoVia1.value = args.numeroTipoVia1}
  }
  if(args.descrTipoVia2){
    let descrTipoVia2 = document.getElementById("bdescrTipoVia2");
    if(descrTipoVia2){descrTipoVia2.value = args.descrTipoVia2}
  }
  if(args.numeroTipoVia2){
    let numeroTipoVia2 = document.getElementById("bnumeroTipoVia2");
    if(numeroTipoVia2){numeroTipoVia2.value = args.numeroTipoVia2}
  }
  if(args.numeroTipoVia2F){
    let numeroTipoVia2F = document.getElementById("bnumeroTipoVia2F");
    if(numeroTipoVia2F){numeroTipoVia2F.value = args.numeroTipoVia2F}
  }

  if(args.mac){
    let mac = document.getElementById("bmac");
    if(mac){mac.value = args.mac}
  }
  if(args.codigoMarquilla){
    let codigoMarquilla = document.getElementById("bcodigoMarquilla");
    if(codigoMarquilla){codigoMarquilla.value = args.codigoMarquilla}
  }

  if(args.estadoCliente){
    let estadoCliente = document.getElementById("bestadoCliente");
    if(estadoCliente){estadoCliente.value = args.estadoCliente}
  }
  if(args.descrEstrato){
    let descrEstrato = document.getElementById("bdescrEstrato");
    if(descrEstrato){descrEstrato.value = args.descrEstrato}
  }
  if(args.telefono){
    let telefono = document.getElementById("btelefono");
    if(telefono){telefono.value = args.telefono}
  }
  if(args.numeroDoc){
    let numeroDoc = document.getElementById("bnumeroDoc");
    if(numeroDoc){numeroDoc.value = args.numeroDoc}
  }
  if(args.descrTipoCliente){
    let descrTipoCliente = document.getElementById("bdescrTipoCliente");
    if(descrTipoCliente){descrTipoCliente.value = args.descrTipoCliente}
  }
  if(args.descrGrupoAfin){
    let descrGrupoAfin = document.getElementById("bdescrGrupoAfin");
    if(descrGrupoAfin){descrGrupoAfin.value = args.descrGrupoAfin}
  }
// console.log(args)
//Traer autorizaciones
  const a0105 = autorizacUA.findIndex( autorizac => autorizac === "0105" );
  const a0110 = autorizacUA.findIndex( autorizac => autorizac === "0110" );
  const a0115 = autorizacUA.findIndex( autorizac => autorizac === "0115" );
  const a0120 = autorizacUA.findIndex( autorizac => autorizac === "0120" );
  const a0125 = autorizacUA.findIndex( autorizac => autorizac === "0125" );
  const a0130 = autorizacUA.findIndex( autorizac => autorizac === "0130" );
  const a0140 = autorizacUA.findIndex( autorizac => autorizac === "0140" );
  const a0145 = autorizacUA.findIndex( autorizac => autorizac === "0145" );
  const a0150 = autorizacUA.findIndex( autorizac => autorizac === "0150" );
  // const a0135 = autorizacUA.findIndex( autorizac => autorizac === "0135" );

  return (
    <div>
      <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
        <div>
          <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
            <i className="large search yellow icon"></i>
            Buscar
          </button>

          <div className="ui input fluid">
            <input id='numDocum' name="numDocum" type="number" placeholder="Traer 50 clientes" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='contrato' autoComplete="off" name="contrato" type="text" placeholder="Contrato" autoFocus style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bnombreCliente' autoComplete="off" name="nombreCliente" type="text" placeholder="Nombre(s)" style={styles.dropdown} onChange={handleChange}/>
            {/* <input name="nombreCliente" type="text" placeholder="Nombre(s)" style={styles.dropdown} onChange={handleChange} /[A-Z]{3}[0-9]{4}/" title="El formato debe coincidir con 3 letras mayúsculas y 4 números."/> */}
          </div>
          <div className="ui input fluid">
            <input id='bapellidoCliente' autoComplete="off" name="apellidoCliente" type="text" placeholder="Apellido(s)" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bdescrClaseServ' autoComplete="off" name="descrClaseServ" type="text" placeholder="Clase de servicio" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bdescrSubclaseServ' autoComplete="off" name="descrSubclaseServ" type="text" placeholder="Subclase de servicio" style={styles.dropdown} onChange={handleChange}/>
          </div>

          <div className="ui input fluid">
            <input id='bdescrDpto' autoComplete="off" name="descrDpto" type="text" placeholder="Departamento" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bnombreCiudad' autoComplete="off" name="nombreCiudad" type="text" placeholder="Ciudad" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bnombreZona' autoComplete="off" name="nombreZona" type="text" placeholder="Zona" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bnombreBarrio' autoComplete="off" name="nombreBarrio" type="text" placeholder="Barrio" style={styles.dropdown} onChange={handleChange}/>
          </div>

          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '21.5%', paddingRight: '0em'}}>
                <div className="ui input fluid">
                  <input id='bdescrTipoVia1' autoComplete="off" name="descrTipoVia1" type="text" placeholder="Di" style={styles.dropdown} onChange={handleChange}/>
                </div>
              </div>
              <div className="column" style={{width: '19%', paddingLeft: '0em', paddingRight: '0em'}}>
                <div className="ui input fluid">
                  <input id='bnumeroTipoVia1' autoComplete="off" name="numeroTipoVia1" type="text" placeholder="re" style={styles.dropdown} onChange={handleChange}/>
                </div>
              </div>
              <div className="column" style={{width: '19%', paddingLeft: '0em', paddingRight: '0em'}}>
                <div className="ui input fluid">
                  <input id='bdescrTipoVia2' autoComplete="off" name="descrTipoVia2" type="text" placeholder="cc" style={styles.dropdown} onChange={handleChange}/>
                </div>
              </div>
              <div className="column" style={{width: '19%', paddingLeft: '0em', paddingRight: '0em'}}>
                <div className="ui input fluid">
                  <input id='bnumeroTipoVia2' autoComplete="off" name="numeroTipoVia2" type="text" placeholder="i" style={styles.dropdown} onChange={handleChange}/>
                </div>
              </div>
              <div className="column" style={{width: '21.5%', paddingLeft: '0em'}}>
                <div className="ui input fluid">
                  <input id='bnumeroTipoVia2F' autoComplete="off" name="numeroTipoVia2F" type="text" placeholder="ón" style={styles.dropdown} onChange={handleChange}/>
                </div>
              </div>
            </div>
          </div>

          <div className="ui input fluid">
            <input id='bmac' autoComplete="off" name="mac" type="text" placeholder="Mac" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bcodigoMarquilla' autoComplete="off" name="codigoMarquilla" type="text" placeholder="Marquilla" style={styles.dropdown} onChange={handleChange}/>
          </div>

          <div className="ui input fluid">
            <input id='bestadoCliente' autoComplete="off" name="estadoCliente" type="text" placeholder="Estado" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bdescrEstrato' autoComplete="off" name="descrEstrato" type="text" placeholder="Estrato" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='btelefono' autoComplete="off" name="telefono" type="text" placeholder="Teléfono" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bnumeroDoc' autoComplete="off" name="numeroDoc" type="text" placeholder="No. Documento" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bdescrTipoCliente' autoComplete="off" name="descrTipoCliente" type="text" placeholder="Tipo de cliente" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='bdescrGrupoAfin' autoComplete="off" name="descrGrupoAfin" type="text" placeholder="Grupo de afinidad" style={styles.dropdown} onChange={handleChange}/>
          </div>

      {/* {CLRPT!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
            <i className="large sitemap yellow icon"></i>
            Opciones
          </button>

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelRPT}>
            <i className="large edit violet icon"></i>
            Recibir pago - Terceros
          </button>
        </div>
      } */}
          <Divider inverted />

          {(a0105!==-1||a0110!==-1||a0115!==-1||a0120!==-1) &&
          <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
            <i className="large settings yellow icon"></i>
            Configurar para clientes
          </button>
          }
          {a0105!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDir}>
            <i className="large map marker alternate violet icon"></i>
            Direcciones
          </button>
          }
          {a0110!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickTC}>
            <i className="large asl interpreting violet icon"></i>
            Tipos de cliente
            </button>
          }
          {a0115!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickGA}>
            <i className="large handshake outline violet icon"></i>
            Grupos de afinidad
            </button>
          }
          {a0120!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickTD}>
            <i className="large object group outline violet icon"></i>
            Tipos de documento
          </button>
          }
          {a0125!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickCF}>
            <i className="large refresh violet icon"></i>
            Ciclos de facturación
          </button>
          }
          {a0130!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickOP}>
            <i className="large object group outline violet icon"></i>
            Conceptos de otros pagos del cliente
          </button>
          }
          {a0140!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickOf}>
            <i className="large object group outline violet icon"></i>
            Oficinas
          </button>
          }
          {a0145!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSeg}>
            <i className="large object group outline violet icon"></i>
            Segmentos
          </button>
          }
          {a0150!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickPaq}>
            <i className="large object group outline violet icon"></i>
            Paquetes
          </button>
          }

          {/* {a0135!==-1 &&
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickTA}>
            <i className="large object group outline violet icon"></i>
            Tipos de ajuste
          </button>
          } */}
        </div>
      </Form>
    </div>
  )
};

export default HomeCli1
